import { i18n } from '@/core/lib/i18n';
import type { IOdds, IPrice } from '@/interface/IOdds';
import { MarketType, OddsOption } from '@/interface/enum';

type BetOptionFormatter = (odds: IOdds, price: IPrice) => string;

const hdpBetOptionFormatter: BetOptionFormatter = (_odds, price) => {
    if (price.option === OddsOption.Home) return i18n.t('odds_option_home');
    if (price.option === OddsOption.Away) return i18n.t('odds_option_away');
    return '';
};

const ouBetOptionFormatter: BetOptionFormatter = (_odds, price) => {
    if (price.option === OddsOption.Over) return i18n.t('odds_option_over');
    if (price.option === OddsOption.Under) return i18n.t('odds_option_under');
    return '';
};

const oneX2BetOptionFormatter: BetOptionFormatter = (_odds, price) => {
    if (price.option === OddsOption._1X2_1) return '1';
    if (price.option === OddsOption._1X2_2) return '2';
    if (price.option === OddsOption._1X2_X) return 'X';
    return '';
};

const rulesConfig: Partial<Record<MarketType, BetOptionFormatter>> = {
    [MarketType.Handicap]: hdpBetOptionFormatter,
    [MarketType.FH_Handicap]: hdpBetOptionFormatter,
    [MarketType.OverUnder]: ouBetOptionFormatter,
    [MarketType.FH_OverUnder]: ouBetOptionFormatter,
    [MarketType._1X2]: oneX2BetOptionFormatter,
    [MarketType.FH_1X2]: oneX2BetOptionFormatter,
};

export function getTournamentBetOptionDisplay(odds: IOdds, price: IPrice): string {
    const formatter = rulesConfig[odds.marketType];
    if (formatter) {
        const result = formatter(odds, price);
        if (result) {
            return result;
        }
    }
    return price.option;
}
